import React, { useCallback } from 'react';
import { StatusListInterface } from '../../interfaces/ProjectInterface';
import { TaskGroupInterface } from '../../interfaces/TaskInterface';
import { ProjectModel } from '../../mobx/models/project';
import { ProjectTemplateModel } from '../../mobx/models/projectTemplate';
import GroupDropdown from '../dropdowns/statusDropdown';
import TaskStatusDropdownV2 from '../dropdowns/taskStatusDropdown';
import IconButton from '../button/iconButton';
import Tooltip from '../tooltip';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../global/constants';
import { Bottom, BulkAction, RightSection, SelectBox, SelectedTask } from './style';

interface Props {
  selectedTasks: { taskId: string; groupId: string }[];
  currentProject?: ProjectModel | ProjectTemplateModel;
  onBulkUpdateGroup?: (group: TaskGroupInterface, tasks: { taskId: string; groupId: string }[]) => void;
  onBulkUpdateStatus: (
    status: StatusListInterface,
    previousStatus: StatusListInterface,
    tasks: { taskId: string; groupId: string }[]
  ) => void;
  openSelectedDeleteModal: () => void;
  onRemoveSelectedTasks: () => void;
  showGroupAction?: boolean;
  isTaskDetail?: boolean;
}

const BulkActionControls: React.FC<Props> = ({
  selectedTasks,
  currentProject,
  onBulkUpdateGroup,
  onBulkUpdateStatus,
  openSelectedDeleteModal,
  onRemoveSelectedTasks,
  showGroupAction = true,
  isTaskDetail
}) => {
  const handleUpdateStatus = useCallback(
    (status: StatusListInterface, previousStatus: StatusListInterface) =>
      onBulkUpdateStatus(status, previousStatus, selectedTasks),
    [onBulkUpdateStatus, selectedTasks]
  );

  return (
    <>
      <Bottom isTaskDetail={isTaskDetail}>
        <SelectBox>
          <SelectedTask>{selectedTasks?.length} Selected Tasks</SelectedTask>
          <RightSection>
            <BulkAction>
              {showGroupAction && currentProject && currentProject?.isGroupEnabled && onBulkUpdateGroup && (
                <Tooltip title='Group' maxWidth={'max-content'} placement='bottom'>
                  <GroupDropdown
                    currentProject={currentProject}
                    onUpdateGroup={(group) =>
                      onBulkUpdateGroup(group, selectedTasks as { taskId: string; groupId: string }[])
                    }
                    isIconButton={true}
                  />
                </Tooltip>
              )}
              {currentProject?.statusEnable && currentProject?.statusData?.length > 0 && (
                <Tooltip title='Status' maxWidth={'max-content'} placement='bottom'>
                  <TaskStatusDropdownV2
                    defaultStatus={currentProject?.defaultStatus}
                    statusList={currentProject?.statusData || []}
                    isIconButton={true}
                    onUpdateStatus={handleUpdateStatus}
                  />
                </Tooltip>
              )}
              <Tooltip title='Delete' maxWidth={'max-content'} placement='bottom'>
                <IconButton
                  variant={ICON_BUTTON_TYPE.TERTIARY}
                  size={ICON_BUTTON_SIZE.MEDIUM}
                  iconName='updated-delete-icon'
                  onClick={openSelectedDeleteModal}
                />
              </Tooltip>
            </BulkAction>
            <Tooltip title='Close' maxWidth={'max-content'} placement='bottom'>
              <IconButton
                variant={ICON_BUTTON_TYPE.TERTIARY}
                size={ICON_BUTTON_SIZE.MEDIUM}
                iconName='new-close-icon'
                onClick={onRemoveSelectedTasks}
              />
            </Tooltip>
          </RightSection>
        </SelectBox>
      </Bottom>
    </>
  );
};

export default BulkActionControls;
